/*
 * Microsoft Authentication Library (MSAL) Configuration
 * This configuration is used for Microsoft Authentication in the application
 */

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || '',
    authority: process.env.REACT_APP_MICROSOFT_AUTHORITY || 'https://login.microsoftonline.com/common',
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // cacheLocation: 'sessionStorage', // Set to 'localStorage' for persistent login
    cacheLocation: 'localStorage', // Set to 'localStorage' for persistent login
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Set to true if using WAM
    asyncPopups: false, // Set to true to enable async popups
    tokenRenewalOffsetSeconds: 20,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error(message);
            break;
          case 1: // Warning
            console.warn(message);
            break;
          case 2: // Info
            console.info(message);
            break;
          case 3: // Verbose
            console.debug(message);
            break;
          default:
            break;
        }
      },
      piiLoggingEnabled: false,
      logLevel: 2, // Info
    }
  }
};

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
}; 